module.exports = __webpack_public_path__ + "img/14_41.4bd75141.png";